var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 0.3,
    y: 0.3,
    width: 79.4,
    height: 79.4,
    fill: "#E9E9E9",
    stroke: "#999999",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"add a photo\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 26.3335V22.3335H30.6667V26.3335H34.6667V29.0002H30.6667V33.0002H28V29.0002H24V26.3335H28ZM32 34.3335V30.3335H36V26.3335H45.3333L47.7733 29.0002H52C53.4667 29.0002 54.6667 30.2002 54.6667 31.6668V47.6668C54.6667 49.1335 53.4667 50.3335 52 50.3335H30.6667C29.2 50.3335 28 49.1335 28 47.6668V34.3335H32ZM41.3333 46.3335C45.0133 46.3335 48 43.3468 48 39.6668C48 35.9868 45.0133 33.0002 41.3333 33.0002C37.6533 33.0002 34.6667 35.9868 34.6667 39.6668C34.6667 43.3468 37.6533 46.3335 41.3333 46.3335ZM37.0667 39.6668C37.0667 42.0268 38.9733 43.9335 41.3333 43.9335C43.6933 43.9335 45.6 42.0268 45.6 39.6668C45.6 37.3068 43.6933 35.4002 41.3333 35.4002C38.9733 35.4002 37.0667 37.3068 37.0667 39.6668Z",
    fill: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.7e9d054a396917a12bfcdc0c43a810d0.svg";
export { ForwardRef as ReactComponent };